module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABTElEQVRIS+3Wu2tXQRQE4G9AsFOxsTAgdpaxEMQqCCm0EV/4Byi2KlaCZSBVXq1oH/GFjRaCWIWAhSnThUBS2AQVG4OwcuQK8vOa7oqEnO6yMzu7e2Z2b1prB/EAl7DPn/UZM5hK0mq4tRbcx10Uf7S+4zluprW2iGt4is0e8Bmcwo0kjzqB63iI91jq4RzFFTwugW28THK1B1ir3Y91fEhyrhN4jZM4luTbX3hPcKEEatsLSW73AbsJV/ApyUT3/Q6HkozvwJnHrT2B/+OIvmIZk798/nvjWmuHsYa3SS52TX6BszieZGu00V1O3uB0NXkWd7CKjz2uOIEjOJ+k7FnWLbu+6vDFG63CF2+uBCq991A5ONAD3vgJTJ6N7Oxyt7CxHs4XVA6mK/KD1vACgx/Rv2jy4Dbdu+x6bd5a20XX9eBP5uCP/qC/LT8A6xtqSvS9MigAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/canvasImg/panel/shangpinlieb1@2x.png
// module id = RYF0
// module chunks = 14